import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminSyncIndexes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      return apiClient.catalogs.syncIndexes.mutation({
        body: undefined,
      });
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ['admin-catalogs-info'] });
      const complete = (response.body as { complete: boolean }).complete;
      toast.success(complete ? 'Indexes synced successfully' : 'Indexes sync is in progress');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to sync indexes');
    },
  });
};
